import React from 'react';
import './Logo.css';

const Logo = ({ variant = 'default' }) => {
  return (
    <div className={`company-logo ${variant}`}>
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="100%" stopColor="#764ba2" />
          </linearGradient>
        </defs>
        {/* Outer hexagon */}
        <path d="M25 3 L43 13.5 L43 34.5 L25 45 L7 34.5 L7 13.5 Z" 
              stroke="url(#logoGradient)" 
              strokeWidth="2.5" 
              fill="none"/>
        {/* Inner S shape */}
        <path d="M25 15 C29 15, 32 17, 32 20 C32 23, 29 24, 25 24 C21 24, 18 26, 18 29 C18 32, 21 34, 25 34" 
              stroke="url(#logoGradient)" 
              strokeWidth="3" 
              strokeLinecap="round"
              fill="none"/>
        {/* R element */}
        <circle cx="35" cy="25" r="2" fill="url(#logoGradient)"/>
      </svg>
      <div className="logo-text-container">
        <span className="logo-company-name">Sami Rafael</span>
        <span className="logo-subtitle">LLC</span>
      </div>
    </div>
  );
};

export default Logo;

